import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';

import { BenefitsList } from './BenefitsList';
import { BenefitsTabList } from './BenefitsTabList';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function BenefitsSection() {
  const { productConfig } = useProductLandingContext();
  const { benefit } = productConfig;
  const { title, items = [], defaultCategory } = benefit || {};

  // Has categories when items is an object (not array) with category keys
  const hasCategories = !Array.isArray(items) && Object.keys(items).length > 0;

  if (items.length === 0 && !hasCategories) {
    return null;
  }

  return (
    <Stack gap={4}>
      {title && (
        <Heading component="h2" size="xl" wrap="wrap">
          <FormattedMessage id={title} />
        </Heading>
      )}
      {hasCategories ? (
        <BenefitsTabList items={items} defaultValue={defaultCategory} />
      ) : (
        <BenefitsList items={items} />
      )}
    </Stack>
  );
}

export default BenefitsSection;
